import styled from "styled-components"

export const StyledPricing = styled.div`
  display: flex;
  gap: 1rem;
`

export const Effect = styled.div`
  flex: 1;
`

export const Value = styled.div`
  flex: 1;
`
